import { useTranslations } from 'next-intl';
import { INLINE_TAGS, storyItemKey } from '../../_const/stories';
import DayBadge from '../../_components/day-badge';

/** 배지·제목·이름·소속(공개 정보 en.json). 제목은 늘 h1 — 모달에서는 showModal 이 바깥을 inert 로 만든다 */
export default function StoryHeader({
  day,
  titleId,
}: {
  day: number;
  titleId?: string;
}) {
  const t = useTranslations('TenYears.stories');
  const key = storyItemKey(day);
  const role = t(`items.${key}.role`);
  return (
    <div className="p-5 lg:p-10">
      <DayBadge day={day} className="inline-block" />
      <h1
        id={titleId}
        className="mt-5 text-[36px] font-semibold leading-[44px] tracking-[-0.784px] text-3b-text-primary lg:pr-[120px] lg:text-[48px] lg:leading-[56px] lg:tracking-[-1.072px]"
      >
        {t.markup(`items.${key}.title`, INLINE_TAGS)}
      </h1>
      <p className="mt-3 text-[18px] font-medium leading-7 tracking-[-0.256px]">
        <span className="block text-3b-text-primary">
          {t(`items.${key}.name`)}
        </span>
        {role && <span className="mt-0.5 block text-ty-gray-500">{role}</span>}
      </p>
    </div>
  );
}
